<template>
  <section class="rosa-graf">
    <div class="jumbotron jumbotron-fluid">
      <div class="container-fluid fade-in">
        <div class="row">
          <div class="col-12">
            <div class="logo">
              <img src="../../../assets/images/rg_logo.svg" alt="Logo von Rosa Graf">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h1 class="text-center">ROSA GRAF Premium Kosmetik - 100% Made in Germany</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-10 offset-1 text-center">
            <p><b>Unser Ziel ist es, die natürliche Schönheit jeder Frau zu erhalten und zu fördern.</b>
              Als Kosmetikpionierin hatte sich bereits Frau Rosa Graf in den 20er Jahren des letzten
              Jahrhunderts dieses Ziel auf ihre Fahne geschrieben. Sie leitete eine der ersten
              Kosmetikschulen Deutschlands und ließ Produkte speziell für den Bedarf der Fachkosmetikerin
              nach eigenen Rezepturen herstellen</p>
            <p><b>Das Haus Heitland & Petre ist dieer Tradition verpflichtet.</b> Unser Produktionsprogramm
              umfasst eine große Palette exklusiver Kosmetikprodukte für
              Behandlung und Verkauf im Institut.</p>
            <p>Führend in Forschung und Entwicklung seit 1926</p>
            <span class="text-2">Wer gut aussieht, fühlt sich wohl!</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RosaGraf"
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

.rosa-graf {
  h1, p, span {
    color: $white;
  }

  .jumbotron {
    position: relative;
    background: $black;
    padding: 25px 0;

    .container-fluid {
      max-width: 95%;
    }
  }

  .logo {
    max-width: 100px;
    margin: 15px auto 0 auto;
  }
}
</style>
